<template>
  <div>
    <v-container fluid>
      <!-- Modern Header -->
      <!-- <div class="page-header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="page-title">{{ $t('SettingExternalConnector') }}</h1>
          <p class="page-subtitle">Manage your API tokens and external connections</p>
        </div>
        <div class="header-right">
          <div class="date-badge">{{ today }}</div>
        </div>
      </div>
    </div> -->
      <div class="page-header">
        <v-skeleton-loader
          :loading="!flagNav"
          transition="scale-transition"
          max-height="64"
          type="table-heading"
        >
          <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
              $t("SettingExternalConnector")
            }}</v-toolbar-title>
            <v-spacer />
            <div class="d-flex pr-4">
              <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
            </div>
          </v-toolbar>
        </v-skeleton-loader>
      </div>

      <!-- Main Content Card -->
      <div class="main-card">
        <!-- Modern Tabs -->
        <div class="tabs-container">
          <div class="tabs-wrapper">
            <div
              v-for="(item, index) in items"
              :key="item.tab"
              class="tab-item"
              :class="{ active: tab === index }"
              @click="tab = index"
            >
              <span class="tab-text">{{ item.tab }}</span>
            </div>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <div v-for="(item, index) in items" :key="item.tab">
            <div v-if="index === tab" class="tab-panel">
              <!-- Token Management Panel -->
              <div
                v-if="item.dataResponse != null"
                class="token-management-panel"
              >
                <!-- Action Bar -->
                <div class="action-bar">
                  <div class="search-section">
                    <!-- Search functionality can be added here -->
                  </div>
                  <button class="add-button" @click="Add()">
                    <v-icon size="18">mdi-plus</v-icon>
                    <span>{{ $t("add") }} Token</span>
                  </button>
                </div>

                <!-- Modern Data Table -->
                <div class="table-container">
                  <v-data-table-server
                    v-model:options="options"
                    :headers="headers2"
                    :items="item.dataResponse"
                    item-key="TokenName"
                    :items-per-page="options.itemsPerPage"
                    :items-per-page-options="[5, 10, 25, 50, 100]"
                    :items-length="searchTotalTable"
                    :loading="dialog"
                    class="modern-table"
                    loading-text="Loading... Please wait"
                  >
                    <!-- API Key Display -->
                    <template v-slot:item.apI_Key="{ item }">
                      <div class="api-key-container">
                        <div class="api-key-display">
                          <input
                            :type="item.show_status ? 'text' : 'password'"
                            :value="item.apI_Key"
                            class="api-key-input"
                            readonly
                          />
                          <button class="icon-button" @click="ShowAPIKey(item)">
                            <v-icon size="16">{{
                              item.show_status ? "mdi-eye" : "mdi-eye-off"
                            }}</v-icon>
                          </button>
                          <button
                            v-if="item.show_status"
                            class="icon-button copy-button"
                            @click="ClipboardAPIKey(item)"
                          >
                            <v-icon size="16">mdi-content-copy</v-icon>
                          </button>
                        </div>
                        <div v-if="item.copy_status" class="copy-toast">
                          Copied! ✓
                        </div>
                      </div>
                    </template>

                    <!-- Status Badge -->
                    <template v-slot:item.status="{ item }">
                      <div
                        class="status-badge"
                        :class="{ active: item.status, expired: !item.status }"
                      >
                        {{ item.status ? "Active" : "Expired" }}
                      </div>
                    </template>

                    <!-- Actions Menu -->
                    <template v-slot:item.actions="{ item }">
                      <v-menu location="bottom" allow-overflow>
                        <template v-slot:activator="{ props }">
                          <button class="action-menu-button" v-bind="props">
                            <v-icon size="16">mdi-dots-vertical</v-icon>
                          </button>
                        </template>
                        <v-list class="action-menu">
                          <v-list-item
                            v-for="(val, menuIndex) in DDList"
                            :key="menuIndex"
                            @click="displayActions(item, menuIndex)"
                            class="action-item"
                          >
                            <v-list-item-title>{{
                              val.title
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table-server>
                </div>
              </div>

              <!-- API Documentation Panel -->
              <div v-else class="api-docs-panel">
                <div class="docs-layout">
                  <!-- Left Side - Parameters -->
                  <div class="docs-left">
                    <div class="section-card">
                      <h3 class="section-title">Parameters</h3>

                      <div
                        v-for="(child, no_run) in item.scriptAndParam"
                        :key="child.content"
                        class="param-item"
                      >
                        <div
                          v-if="no_run === 1 && index > 1 && index !== 8"
                          class="divider"
                        >
                          <h4 class="divider-title">Request</h4>
                        </div>

                        <div class="param-header">
                          <h4 class="param-name">{{ child.content }}</h4>
                          <span v-if="child.dataType" class="param-type">{{
                            child.dataType
                          }}</span>
                          <v-tooltip v-if="child.tooltip" location="top">
                            <template v-slot:activator="{ props: attrs, on }">
                              <v-icon
                                size="16"
                                v-bind="attrs"
                                v-on="on"
                                class="info-icon"
                              >
                                mdi-information
                              </v-icon>
                            </template>
                            <span>{{ child.tooltip }}</span>
                          </v-tooltip>
                        </div>

                        <div class="param-input">
                          <textarea
                            v-model="child.script"
                            :readonly="child.readonly"
                            class="modern-textarea"
                            @input="updateExampleCode(index)"
                            @focus="$event.target.select()"
                          ></textarea>
                          <button
                            class="copy-param-button"
                            @click="copyClipboard(no_run, 'left')"
                          >
                            <v-icon size="14">mdi-content-copy</v-icon>
                          </button>
                        </div>
                      </div>

                      <!-- Response Section -->
                      <div
                        v-if="item.responseStatus || item.responseDescription"
                        class="response-section"
                      >
                        <h3 class="section-title">Response</h3>

                        <div
                          v-if="item.responseStatus"
                          class="status-responses"
                        >
                          <div
                            v-for="status in item.responseStatus"
                            :key="status.responseMsg"
                            class="status-item"
                          >
                            <div class="status-code">
                              {{ status.responseStatus }}
                            </div>
                            <div class="status-message">
                              {{ status.responseMsg }}
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="item.responseDescription"
                          class="response-table"
                        >
                          <v-data-table
                            :headers="headers"
                            :items="item.responseDescription"
                            item-key="key"
                            hide-default-footer
                            disable-sort
                            class="modern-response-table"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Right Side - Code Examples -->
                  <div class="docs-right">
                    <div class="section-card">
                      <div class="code-header">
                        <v-row>
                          <v-col cols="3">
                            <h3 class="section-title">Code Examples</h3>
                          </v-col>
                          <v-col cols="9">
                            <v-select
                              v-if="tab > 2"
                              v-model="selectVersion"
                              :items="versions"
                              item-title="title"
                              item-value="value"
                              class="modern-input d-flex align-center justify-end"
                              density="comfortable"
                              variant="outlined"
                              hide-details
                              @update:modelValue="switchVersion"
                            />
                          </v-col>
                        </v-row>
                      </div>

                      <div
                        v-for="(child, no_run) in item.example"
                        :key="child.contentEx"
                        class="code-example"
                      >
                        <div class="code-label">{{ child.contentEx }}</div>
                        <div class="code-container">
                          <prism-editor
                            id="codeEditor"
                            class="my-editor"
                            v-model="child.codeEx"
                            :highlight="highlighter"
                            :line-numbers="true"
                            :auto-style-line-numbers="true"
                            :ignore-tab-key="true"
                            readonly
                          />
                          <button
                            class="copy-code-button"
                            @click="copyClipboard(no_run, 'right')"
                          >
                            <v-icon size="16">mdi-content-copy</v-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dialogs remain the same but with updated styling -->
      <!-- Show Token Dialog -->
      <v-dialog
        v-model="dialogShowToken"
        max-width="600px"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <div class="dialog-header">
            <div class="header-icon">
              <v-icon size="24" color="primary">mdi-key-variant</v-icon>
            </div>
            <div class="header-content">
              <h3 class="dialog-title">API Key</h3>
              <p class="dialog-subtitle">Your secure access token</p>
            </div>
            <v-btn
              icon
              variant="text"
              size="small"
              @click="dialogShowToken = false"
              class="close-btn"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="dialog-body">
            <div class="usage-info">
              <div class="info-card">
                <v-icon size="16" color="info" class="info-icon"
                  >mdi-information</v-icon
                >
                <span
                  >Use this key in your application by passing it with the
                  <code class="inline-code">key=API_KEY</code> parameter.</span
                >
              </div>
            </div>

            <div class="token-display-container">
              <label class="token-label">Your API Key</label>
              <div class="token-input-wrapper">
                <input
                  :value="token"
                  readonly
                  class="token-input"
                  @focus="$event.target.select()"
                />
                <v-tooltip text="Copy to clipboard" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      id="icon-copy-settingexternalconnector"
                      v-bind="props"
                      icon
                      variant="text"
                      size="small"
                      class="copy-btn"
                      @click="ClipboardAPIKey(editedIndex)"
                    >
                      <v-icon size="18">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </div>
            </div>
          </div>

          <div class="dialog-footer">
            <v-btn
              variant="elevated"
              color="primary"
              @click="dialogShowToken = false"
              class="primary-btn"
            >
              Got it
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Add/Renew Dialog -->
      <v-dialog
        v-model="dialogRenew"
        max-width="700px"
        persistent
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Updated Dialog Header -->
          <div class="dialog-header"
          :class="{ 'dialog-header-add': flagAdd, 'dialog-header-edit': !flagAdd }"
          >
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background add-mode">
                  <v-icon size="20" color="white">
                    {{ flagAdd ? "mdi-plus" : "mdi-refresh" }}
                  </v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">
                  {{ flagAdd ? "Create New Token" : "Renew Token" }}
                </h2>
                <p class="dialog-subtitle">
                  {{
                    flagAdd
                      ? "Generate a secure API access token for your application"
                      : "Update the expiration date and settings for your existing token"
                  }}
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                size="small"
                color="white"
                @click="dialogRenew = false"
                class="close-button"
              >
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="dialog-body">
            <!-- Basic Information -->
            <div class="form-section">
              <h4 class="section-title">Basic Information</h4>
              <div class="form-grid-2">
                <div class="form-group">
                  <label class="form-label">Token Name</label>
                  <v-text-field
                    v-model="tokenName"
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                    :disabled="!flagAdd"
                    placeholder="Enter token name"
                    class="modern-input"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">Email Address</label>
                  <v-text-field
                    v-model="email"
                    :rules="[rules.required, validateEmail(email)]"
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                    placeholder="Enter email address"
                    class="modern-input"
                  />
                </div>
              </div>

              <!-- Current Token Display (Renew only) -->
              <div v-if="!flagAdd" class="current-token">
                <label class="form-label">Current API Key</label>
                <div class="token-display">
                  <input
                    :value="token"
                    readonly
                    class="current-token-input"
                    @focus="$event.target.select()"
                  />
                  <v-tooltip text="Copy to clipboard" location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        variant="text"
                        size="small"
                        class="copy-btn-inline"
                        @click="ClipboardAPIKey(editedItem)"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <!-- Expiration Settings -->
            <div class="form-section">
              <h4 class="section-title">Expiration Settings</h4>
              <v-radio-group v-model="radios" class="radio-group-modern">
                <div class="radio-option">
                  <v-radio value="DDLSelectDate" class="custom-radio">
                    <template v-slot:label>
                      <div class="radio-content">
                        <span class="radio-title">Preset Duration</span>
                        <span class="radio-description"
                          >Choose from common durations</span
                        >
                      </div>
                    </template>
                  </v-radio>
                  <div v-if="radios === 'DDLSelectDate'" class="radio-input">
                    <v-select
                      v-model="DateSelected"
                      :items="ListDate"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="duration-select-modern"
                    />
                  </div>
                </div>

                <div class="radio-option">
                  <v-radio value="CustomeSelectDate" class="custom-radio">
                    <template v-slot:label>
                      <div class="radio-content">
                        <span class="radio-title">Custom Date</span>
                        <span class="radio-description"
                          >Set a specific expiration date</span
                        >
                      </div>
                    </template>
                  </v-radio>
                  <div
                    v-if="radios === 'CustomeSelectDate'"
                    class="radio-input"
                  >
                    <v-menu
                      v-model="menuCustomeDate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      location="bottom start"
                      max-width="290px"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="EndDate"
                          v-bind="props"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          readonly
                          prepend-inner-icon="mdi-calendar"
                          placeholder="Select date"
                          class="date-input-modern"
                        />
                      </template>
                      <v-date-picker
                        v-model="EndDate"
                        @update:model-value="
                          (val) => {
                            EndDate = formatDate(val);
                            menuCustomeDate = false;
                          }
                        "
                        :min="nowDate"
                        :max="getEndDate"
                        elevation="8"
                        rounded="lg"
                      />
                    </v-menu>
                  </div>
                </div>
              </v-radio-group>
            </div>

            <!-- Model Configuration -->
            <div class="form-section">
              <h4 class="section-title">Model Configuration</h4>
              <div class="form-grid-2">
                <div class="form-group">
                  <label class="form-label">Model Display</label>
                  <v-autocomplete
                    v-model="GPTModel"
                    :items="DDGPTModel"
                    item-title="name"
                    item-value="modelDisplayID"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    placeholder="Select model"
                    class="modern-input"
                    clearable
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">Model Group</label>
                  <v-autocomplete
                    v-model="GroupModel"
                    :items="DDGroupModel"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    clearable
                    placeholder="Select group"
                    class="modern-input"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  @click="dialogRenew = false"
                  class="dialog-action-btn cancel-btn"
                >
                  Cancel
                </v-btn>
                <v-btn
                  variant="elevated"
                  :loading="dialog"
                  @click="flagAdd ? CreateNewAPIToken() : Renew()"
                 class="dialog-action-btn"
                 :class="flagAdd ? 'save-btn-add' : 'save-btn-edit'"
                >
                  {{ flagAdd ? "Create Token" : "Update Token" }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- Revoke Dialog -->
      <v-dialog
        v-model="dialogRevoke"
        max-width="500px"
        persistent
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <div class="dialog-header dialog-header-backlist">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background renew-mode">
                  <v-icon size="20" color="white">mdi-alert-circle</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h3 class="dialog-title">Revoke Token</h3>
                <p class="dialog-subtitle">This action cannot be undone</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                size="small"
                color="white"
                @click="dialogRevoke = false"
                class="close-button"
              >
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </div>

            <!-- <div class="header-icon">
              <v-icon size="24" color="error">mdi-alert-circle</v-icon>
            </div>
            <div class="header-content">
              <h3 class="dialog-title">Revoke Token</h3>
              <p class="dialog-subtitle">This action cannot be undone</p>
            </div> -->
          </div>

          <div class="dialog-body">
            <div class="warning-container">
              <div class="warning-content">
                <div class="warning-icon-large">
                  <v-icon size="48" color="error">mdi-shield-alert</v-icon>
                </div>
                <div class="warning-text">
                  <p class="warning-message">
                    This <span class="highlight">API Key</span> will be
                    permanently deleted and can no longer be used to make API
                    requests.
                  </p>
                  <div class="token-info">
                    <span class="token-label-small">Token Name:</span>
                    <span class="token-name-display">{{ tokenName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="dialog-footer">
            <v-btn
              variant="text"
              @click="dialogRevoke = false"
              class="cancel-btn"
            >
              Keep Token
            </v-btn>
            <v-btn
              variant="elevated"
              color="error"
              @click="Revork"
              class="danger-btn"
            >
              Revoke Token
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Loading Overlay -->
      <v-overlay :value="dialog" class="loading-overlay">
        <div class="loading-content">
          <v-progress-circular indeterminate size="64" color="primary" />
          <p class="loading-text">Loading...</p>
        </div>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import LogTrace from "@/api/function.js";
import { PrismEditor } from "vue-prism-editor";
import logoImg from "@/assets/images/chatframework 1.png";
import bgImg from "@/assets/images/bg-ai.png";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-okaidia.css";
import "prismjs/components/prism-rust";

import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
export default {
  mixins: [LogTrace],
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  name: "SettingExternalConnector",
  components: {
    PrismEditor,
  },
  data() {
    return {
      code: "",
      lineNumbers: true,
      expiryDate: "",
      rememberMe: false,
      dialog: false,
      loading: false,
      forgotpassword: false,
      erroralert: false,
      successalert: false,
      successMessage: "",
      errorMessage: "",
      show1: false,
      Email: "",
      images: {
        logo: logoImg,
        BG: bgImg,
      },
      today: null,
      tab: 0,
      yourUsername: "yourUsername",
      yourPassword: "yourPassword",
      headers: [
        { title: "Key", align: "start", sortable: false, value: "key" },
        { title: "Description", align: "start", value: "description" },
        { title: "Type", align: "start", value: "type" },
        { title: "Example", align: "start", value: "ex" },
      ],
      headers2: [
        { title: "No", align: "start", sortable: false, value: "no" },
        {
          title: "Token name",
          align: "start",
          sortable: true,
          value: "tokenName",
        },
        { title: "Email", align: "start", sortable: true, value: "eMail" },
        {
          title: "End date",
          align: "start",
          sortable: true,
          value: "endDataShow",
        },
        {
          title: "Token",
          align: "center",
          width: "300px",
          sortable: false,
          value: "apI_Key",
        },
        { title: "Status", align: "center", sortable: false, value: "status" },
        {
          title: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      DDList: [
        { title: "Renew", menu: 1 },
        { title: "Revork", menu: 2 },
      ],
      showToken: false,
      selectVersion: "v0",
      versions: [
        { title: "Versioned API v0", value: "v0" },
        { title: "Versioned API v1", value: "v1" },
      ],
      items: [
        // Token Management
        {
          tab: "Token Management",
          dataResponse: [],
        },
        // Snippet
        {
          tab: "Snippet",
          example: [
            {
              // Scrip snippet
              contentEx: "Example:HTML snippet",
              codeEx:
                "<!DOCTYPE html>\n" +
                '<html lang="en">\n' +
                "  <head>\n" +
                '    <script src="' +
                import.meta.env.VITE_APP_API +
                'Snippet/ChatFrameworkSnippet.js"></' +
                "script>\n" +
                '    <meta charset="UTF-8">\n' +
                '    <link rel="icon" href="/logo.png" type="image/x-icon">\n' +
                '    <meta name="viewport" content="width=device-width, initial-scale=1.0">\n' +
                "    <title>Chat Framework</title>\n" +
                "  </head" +
                "" +
                ">\n" +
                "</html>",
            },
            {
              // Scrip FullStream
              contentEx: "Example:HTML snippet FullStream",
              codeEx:
                "<!DOCTYPE html>\n" +
                '<html lang="en">\n' +
                "  <head>\n" +
                '    <script src="' +
                import.meta.env.VITE_APP_API +
                'Snippet/ChatFrameworkSnippetFull.js"></' +
                "script>\n" +
                '    <meta charset="UTF-8">\n' +
                '    <link rel="icon" href="/logo.png" type="image/x-icon">\n' +
                '    <meta name="viewport" content="width=device-width, initial-scale=1.0">\n' +
                "    <title>Chat Framework</title>\n" +
                "  </head" +
                "" +
                ">\n" +
                "</html>",
            },
          ],
          scriptAndParam: [
            {
              content: "Script",
              readonly: true,
              script:
                '<script src="' +
                import.meta.env.VITE_APP_API +
                'Snippet/ChatFrameworkSnippet.js"></' +
                "script>\n",
            },
            {
              content: "Script FullStream",
              readonly: true,
              script:
                '<script src="' +
                import.meta.env.VITE_APP_API +
                'Snippet/ChatFrameworkSnippetFull.js"></' +
                "script>\n",
            },
          ],
        },
        // Login Ext
        {
          tab: "Login Ext",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = {
                ${
                  import.meta.env.VITE_APP_ProductAdmin == "true"
                    ? '"companycode":"",'
                    : ""
                }
                "userName": "yourUsername",
                "password": "yourPassword"
              } 
              let responseData = {
                "userId": 0,
                "username": "",
                "fullName": "",
                "passwordUpdateDate": null,
                "memberId": 0,
                "roleId": 0,
                "activeFlag": true,
                "userType": null,
                "token": "",
                "email": null
              }
              axios
                .post(
                  "${
                    import.meta.env.VITE_APP_API
                  }api/v0/ExternalAPI/Login",_data
                )
                .then(function(res) {
                  let resData = res.data;
                  responseData = resData;
                })
                .catch(function(error) {
                  console.log(error);
                });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script: import.meta.env.VITE_APP_API + "api/v0/ExternalAPI/Login",
            },
            {
              content: "Username",
              readonly: false,
              script: "yourUsername",
              dataType: "Data type: string",
            },
            {
              content: "Password",
              readonly: false,
              script: "yourPassword",
              dataType: "Data type: string",
            },
          ],
          responseDescription: [
            {
              key: "userId",
              type: "int",
              description: "ID ผู้ใช้งาน",
              ex: "1",
            },
            {
              key: "username",
              type: "int",
              description: "ชื่อผู้ใช้",
              ex: "testUser",
            },
            {
              key: "fullName",
              type: "int",
              description: "ชื่อจริง",
              ex: "John Stone",
            },
            {
              key: "passwordUpdateDate",
              type: "string",
              description: "วันที่แก้ไขรหัสผ่าน",
              ex: "null",
            },
            {
              key: "memberId",
              type: "int",
              description: "ID ผู้ใช้งาน",
              ex: "1",
            },
            {
              key: "roleId",
              type: "int",
              description: "รหัสตำแหน่ง",
              ex: "1",
            },
            {
              key: "activeFlag",
              type: "bool",
              description: "สถานะการใช้งาน",
              ex: "true",
            },
            {
              key: "token",
              type: "string",
              description: "ไว้สำหรับอนุมัติเข้าใช้งาน API อื่นๆ",
              ex: "eyJhbGciOiJIUzI1N...",
            },
            {
              key: "email",
              type: "string",
              description: "John@Stone.com",
              ex: "John@Stone.com",
            },
          ],
        },
        // Vector Insert (for external)
        {
          tab: "Vector Insert",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = {
  "vectordbName": "test",
  "text": "รายละเอียด",
  "createFlag": true
}
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/CreateVector",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API +
                "api/v0/ExternalAPI/CreateVector",
            },
            {
              content: "vectordbName",
              readonly: false,
              script: "test",
              dataType: "Data type: string",
            },
            {
              content: "text",
              readonly: false,
              script: "รายละเอียด",
              dataType: "Data type: string",
            },
            {
              content: "createFlag",
              readonly: false,
              script: "true",
              dataType: "Data type: bool",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseStatus: [
            {
              responseStatus: "200",
              responseMsg: "Successfully",
            },
          ],
        },
        // List Vector Insert (for external)
        {
          tab: "List Vector Insert",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = {
  "vectordbName": "test",
  "text": ["รายละเอียด1","รายละเอียด2"],
  "createFlag": true
}
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/CreateListVector",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API +
                "api/v0/ExternalAPI/CreateListVector",
            },
            {
              content: "vectordbName",
              readonly: false,
              script: "test",
              dataType: "Data type: string",
            },
            {
              content: "text",
              readonly: false,
              script: '"รายละเอียด1","รายละเอียด2"',
              dataType: "Data type: array[string]",
            },
            {
              content: "createFlag",
              readonly: false,
              script: "true",
              dataType: "Data type: bool",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseStatus: [
            {
              responseStatus: "200",
              responseMsg: "Successfully",
            },
          ],
        },
        // SelectorModel
        {
          tab: "Selector Model",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = { 
  "events": [
    {
      "type": 1,
      "timestamp": 1701821530,
      "source": {
          "userId": "test"
          },
      "message": {
          "text": "1"
          }
    }
  ]
}
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/SelectorModel",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API +
                "api/v0/ExternalAPI/SelectorModel",
            },
            {
              content: "type",
              readonly: false,
              script: "1",
              dataType: "Data type: int",
            },
            {
              content: "timestamp",
              readonly: false,
              script: "1701821530",
              dataType: "Data type: int",
            },
            {
              content: "userId",
              readonly: false,
              script: "test",
              dataType: "Data type: string",
            },
            {
              content: "text",
              readonly: false,
              script: "1",
              dataType: "Data type: string",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseDescription: [
            {
              key: "-",
              type: "string",
              description: "ข้อความตอบกลับแสดง model ที่เลือก",
              ex: "Model Changed to < 1: Azure GPT 3.5 >",
            },
          ],
        },
        // ChatPOST
        {
          tab: "ChatPOST",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = { 
  "events": [
    {
      "type": 1,
      "timestamp": 1701821530,
      "source": {
          "userId": "test"
          },
      "message": {
          "text": "แนะนำเมนูอาหารไทย"
          }
    }
  ]
}
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/ChatPOST",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API + "api/v0/ExternalAPI/ChatPOST",
            },
            {
              content: "type",
              readonly: false,
              script: "1",
              dataType: "Data type: int",
            },
            {
              content: "timestamp",
              readonly: false,
              script: "1701821530",
              dataType: "Data type: int",
            },
            {
              content: "userId",
              readonly: false,
              script: "test",
              dataType: "Data type: string",
            },
            {
              content: "text",
              readonly: false,
              script: "แนะนำเมนูอาหารไทย",
              dataType: "Data type: string",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseDescription: [
            {
              key: "-",
              type: "string",
              description: "ข้อความตอบกลับจากคำถามที่ได้ส่งไป",
              ex: `ผัดไทย - อาหารที่เรียกว่า “สุดยอดของความเป็นไทย” ผัดไทยเป็นอาหารที่มีรสชาติที่ซับซ้อนและสมดุลย์ดี มีรสหวาน, เปรี้ยว, ความเผ็ดและเค็มที่สมดุลย์ดี`,
            },
          ],
        },
        // ChatPromptPOST
        {
          tab: "ChatPromptPOST",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = { 
  "events": [
    {
      "type": 1,
      "timestamp": 1701821530,
      "source": {
          "userId": "test"
          },
      "message": {
          "text": "แนะนำร้านอาหารทะเล",
          "prompttext": "Answer the question using context below. ร้านอาหารที่ดีในกรุงเทพฯ ได้แก่ Le Normandie, Nahm, Gaggan, Eat Me, The Local, Sirocco, Bo.lan, Issaya Siamese Club, ร้านยำที่แนะนำในกรุงเทพฯมีหลายร้าน ได้แก่ ยำวังหลัง, ยำสายไหม, ยำรสเด็ด, ยำแซ่บนัว, ยำครกเพชร, ยำ2นิ้ว และยำแซ่บเวอร์ โดยทุกร้านมีเมนูยำที่หลากหลายและรสชาติเป็นเอกลักษณ์. ร้านอาหารทะเลแถวบางขุนเทียน ร้านทะเลเผา พี่น้อง, ร้านปูเป็น, ร้านเจ๊เนืองซีฟู้ด, ร้านสมพงษ์ซีฟู้ด และ ร้านเจ๊ไข่ซีฟู้ด ซึ่งเป็นร้านที่เชี่ยวชาญในอาหารทะเลและได้รับความนิยมในหมู่ชาวบางขุนเทียน. #context "
          }
    }
  ]
}
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/ChatPromptPOST",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API +
                "api/v0/ExternalAPI/ChatPromptPOST",
            },
            {
              content: "type",
              readonly: false,
              script: "1",
              dataType: "Data type: int",
            },
            {
              content: "timestamp",
              readonly: false,
              script: "1701821530",
              dataType: "Data type: int",
            },
            {
              content: "userId",
              readonly: false,
              script: "test",
              dataType: "Data type: string",
            },
            {
              content: "text",
              readonly: false,
              script: "แนะนำร้านอาหารทะเล",
              dataType: "Data type: string",
            },
            {
              content: "prompttext",
              readonly: false,
              script:
                "Answer the question using context below. ร้านอาหารที่ดีในกรุงเทพฯ ได้แก่ Le Normandie, Nahm, Gaggan, Eat Me, The Local, Sirocco, Bo.lan, Issaya Siamese Club, ร้านยำที่แนะนำในกรุงเทพฯมีหลายร้าน ได้แก่ ยำวังหลัง, ยำสายไหม, ยำรสเด็ด, ยำแซ่บนัว, ยำครกเพชร, ยำ2นิ้ว และยำแซ่บเวอร์ โดยทุกร้านมีเมนูยำที่หลากหลายและรสชาติเป็นเอกลักษณ์. ร้านอาหารทะเลแถวบางขุนเทียน ร้านทะเลเผา พี่น้อง, ร้านปูเป็น, ร้านเจ๊เนืองซีฟู้ด, ร้านสมพงษ์ซีฟู้ด และ ร้านเจ๊ไข่ซีฟู้ด ซึ่งเป็นร้านที่เชี่ยวชาญในอาหารทะเลและได้รับความนิยมในหมู่ชาวบางขุนเทียน. #context",
              dataType: "Data type: string",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseDescription: [
            {
              key: "-",
              type: "string",
              description:
                "ข้อความตอบกลับจะแสดงผลตามที่ได้ใช้ promttext ที่เลือก",
              ex: `ร้านอาหารทะเลแถวบางขุนเทียน มี ร้านทะเลเผา พี่น้อง, ร้านปูเป็น, ร้านเจ๊เนืองซีฟู้ด, ร้านสมพงษ์ซีฟู้ด และ ร้านเจ๊ไข่ซีฟู้ด ซึ่งเป็นร้านที่เชี่ยวชาญในอาหารทะเลและได้รับความนิยมในหมู่ชาวบางขุนเทียน.`,
            },
          ],
        },
        // ImportUser (for external)
        {
          tab: "ImportUser",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = [
  {
    "username": "john",
    "passwrod": "12345678",
    "firstName": "john",
    "lastName": "due",
    "email": "john@due.com",
    "mobile": "0800000000",
    "modelID": "[1,2,3,4]",
    "roleId": 1,
  },
]
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/ImportUser",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API + "api/v0/ExternalAPI/ImportUser",
            },
            {
              content: "username",
              readonly: false,
              script: "john",
              dataType: "Data type: string",
            },
            {
              content: "passwrod",
              readonly: false,
              script: "12345678",
              dataType: "Data type: string",
            },
            {
              content: "firstName",
              readonly: false,
              script: "john",
              dataType: "Data type: string",
            },
            {
              content: "lastName",
              readonly: false,
              script: "due",
              dataType: "Data type: string",
            },
            {
              content: "email",
              readonly: false,
              script: "john@due.com",
              dataType: "Data type: string",
            },
            {
              content: "mobile",
              readonly: false,
              script: "0800000000",
              dataType: "Data type: string",
            },
            {
              content: "modelID",
              readonly: false,
              script: "[1,2,3,4]",
              dataType: "Data type: string",
              tooltip:
                "หากต้องการใช้ ModelID ให้ใช้ตามตัวอย่าง [1,2,3,4] และสามารถใช้ได้เฉพาะ Role User เท่านั้น",
            },
            {
              content: "roleId",
              readonly: false,
              script: "1",
              dataType: "Data type: int",
              tooltip: "RoleID:1 (Admin), RoleID:2 (User)",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseStatus: [
            {
              responseStatus: "200",
              responseMsg: `Successfully`,
            },
          ],
          responseDescription: [
            {
              key: "mesDupUser",
              type: "array[string]",
              description: "Username ถูกใช้งานแล้ว",
              ex: '["john"]',
            },
            {
              key: "mesDupEmail",
              type: "array[string]",
              description: "Email ถูกใช้งานแล้ว",
              ex: '["john@due"]',
            },
            {
              key: "mesEmailNotFormat",
              type: "array[string]",
              description: "Email ไม่ถูกต้อง",
              ex: '["john"]',
            },
            {
              key: "mesFillAll",
              type: "array[string]",
              description: "กรุณากรอกข้อมูลให้ครบถ้วน",
              ex: '["Username:john"]',
            },
            {
              key: "mesModelNotFormat",
              type: "array[string]",
              description:
                "Model ไม่ถูกต้อง ตัวอย่างการใช้งานที่ถูกต้อง [1,2,3]",
              ex: '["[1-3,5]"]',
            },
            {
              key: "mesWarningSuperAdmin",
              type: "array[string]",
              description:
                "ข้อความแสดงถึงการตั้งค่า RoleID ผิด(ควรตั้งเป็น 1(Admin),2(User))",
              ex: '["john"]',
            },
          ],
        },
        // ImportUserChat (for external)
        {
          tab: "ImportUserChat",
          example: [
            {
              // AXIOS
              contentEx: "Example:axios",
              codeEx: `let _data = [
  {
    "username": "john",
    "passwrod": "12345678",
    "firstName": "john",
    "lastName": "due",
    "email": "john@due.com",
    "mobile": "0800000000",
    "modelID": "[1,2,3,4]",
    "socialUserID": "YourSocialUserID(From line)",
    "groupModelName": "yourGroupModelName",
    "modelQuickGroupName": "yourModelQuickGroupName"
  },
]
axios
  .post(
    "${import.meta.env.VITE_APP_API}api/v0/ExternalAPI/ImportUserChat",_data,{
      headers:{
          Authorization: "Bearer yourToken",
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`,
            },
          ],
          scriptAndParam: [
            {
              content: "URL",
              readonly: true,
              script:
                import.meta.env.VITE_APP_API +
                "api/v0/ExternalAPI/ImportUserChat",
            },
            {
              content: "username",
              readonly: false,
              script: "john",
              dataType: "Data type: string",
            },
            {
              content: "passwrod",
              readonly: false,
              script: "12345678",
              dataType: "Data type: string",
            },
            {
              content: "firstName",
              readonly: false,
              script: "john",
              dataType: "Data type: string",
            },
            {
              content: "lastName",
              readonly: false,
              script: "due",
              dataType: "Data type: string",
            },
            {
              content: "email",
              readonly: false,
              script: "john@due.com",
              dataType: "Data type: string",
            },
            {
              content: "mobile",
              readonly: false,
              script: "0800000000",
              dataType: "Data type: string",
            },
            {
              content: "modelID",
              readonly: false,
              script: "[1,2,3,4]",
              dataType: "Data type: string",
              tooltip: "หากต้องการใช้ ModelID ให้ใช้ตามตัวอย่าง [1,2,3,4]",
            },
            {
              content: "socialUserID",
              readonly: false,
              script: "YourSocialUserID(From line)",
              dataType: "Data type: string",
              tooltip:
                "พิมพ์ข้อความ :userid บน Line Chatbot เพื่อรับ socialUserID",
            },
            {
              content: "groupModelName",
              readonly: false,
              script: "yourGroupModelName",
              dataType: "Data type: string",
            },
            {
              content: "modelQuickGroupName",
              readonly: false,
              script: "yourModelQuickGroupName",
              dataType: "Data type: string",
            },
            {
              content: "Token",
              readonly: false,
              script: "yourToken",
              dataType: "Data type: string",
              tooltip: "นำ Token ที่ได้จากการใช้ API: LoginEXT",
            },
          ],
          responseStatus: [
            {
              responseStatus: "200",
              responseMsg: `Successfully`,
            },
          ],
          responseDescription: [
            {
              key: "mesDupUser",
              type: "array[string]",
              description: "Username ถูกใช้งานแล้ว",
              ex: '["john"]',
            },
            {
              key: "mesDupEmail",
              type: "array[string]",
              description: "Email ถูกใช้งานแล้ว",
              ex: '["john@due"]',
            },
            {
              key: "mesEmailNotFormat",
              type: "array[string]",
              description: "Email ไม่ถูกต้อง",
              ex: '["john"]',
            },
            {
              key: "mesFillAll",
              type: "array[string]",
              description: "กรุณากรอกข้อมูลให้ครบถ้วน",
              ex: '["Username:john"]',
            },
            {
              key: "mesModelNotFormat",
              type: "array[string]",
              description:
                "Model ไม่ถูกต้อง ตัวอย่างการใช้งานที่ถูกต้อง [1,2,3]",
              ex: '["[1-3,5]"]',
            },
            {
              key: "mesDupSocialUserID",
              type: "array[string]",
              description: "SocialUserID ถูกใช้งานแล้ว",
              ex: '["SocialID"]',
            },
          ],
        },
      ],
      myClipboard: "",
      urlApi: import.meta.env.VITE_APP_API,
      dialogShowToken: false,
      editedIndex: null,
      editedItem: null,
      token: null,
      tokenName: null,
      email: null,
      dialogActions: false,
      dialogRenew: false,
      dialogRevoke: false,
      EndDate: "",
      radios: "",
      nowDate: new Date().toISOString().slice(0, 10),
      date: new Date(),
      // dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      menuCustomeDate: false,
      ListDate: [
        { title: "30 Days", value: 30 },
        { title: "60 Days", value: 60 },
        { title: "90 Days", value: 90 },
        { title: "120 Days", value: 120 },
      ],
      DateSelected: 30,
      endDate: null,
      showPass: false,
      flagAdd: false,
      addItem: {
        tokenName: "",
        eMail: "",
        endDate: "",
        apI_Key: "",
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      searchTotalTable: 0,
      itemsPerPage: 10,
      totalTable: 0,
      isFirst: true,
      ProductAdminFlag: false,
      id: 0,
      rules: {
        required: (value) => !!value || "Required.",
      },
      DDGPTModel: [],
      DDGroupModel: [],
      GPTModel: null,
      GroupModel: null,
    };
  },
  async created() {
    this.ProductAdminFlag = import.meta.env.VITE_APP_ProductAdmin === "true";
  },
  mounted: function () {
    this.GetDate();
    this.GetDDGPTModel();
    this.GetDDGroupModel();
  },
  computed: {
    getEndDate() {
      let endDate = new Date(
        this.date.getFullYear() + 1,
        this.date.getMonth(),
        this.date.getDate() + 1
      );
      return endDate.toISOString().slice(0, 10);
    },
  },
  watch: {
    options: {
      handler() {
        this.GetAPIData();
      },
      deep: true,
      immediate: true,
    },
    tab: {
      handler(val) {
        let self = this;
        if (val == 6 || val == 7) {
          // CHATPOST || ChatPromptPOST
          self.versions = [
            { title: "Versioned API v0", value: "v0" },
            { title: "Versioned API v1", value: "v1" },
            { title: "Versioned API v2", value: "v2" },
            { title: "Versioned API v3", value: "v3" },
          ];
        } else if (val == 5) {
          if (self.selectVersion == "v2") {
            self.selectVersion = "v1";
          }
          self.versions = [
            { title: "Versioned API v0", value: "v0" },
            { title: "Versioned API v1", value: "v1" },
            { title: "Versioned API v3", value: "v3" },
          ];
        } else {
          if (self.selectVersion == "v2") {
            self.selectVersion = "v1";
          }
          self.versions = [
            { title: "Versioned API v0", value: "v0" },
            { title: "Versioned API v1", value: "v1" },
          ];
        }
      },
    },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || "invalid email";
    },
    async GetAPIData() {
      try {
        let self = this;
        self.dialog = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }

        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        let start = (page - 1) * itemsPerPage;
        await self.$call.GetAPITokenData(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.items[0].dataResponse = dataResponse.data.data.map(
                (items, index) => ({
                  ...items,
                  endDate: self.convertDateToStringFormatDatePick(
                    items.endDate
                  ),
                  endDataShow: self.convertDateToString(items.endDate),
                  show_status: false,
                  copy_status: false,
                  no: start + (index + 1),
                })
              );
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
              self.searchTotalTable = dataResponse.data.total;
            } else {
              self.items[0].dataResponse = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    convertDateToStringFormatDatePick(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringFromDate(moment(date).toDate(), seperator);
    },
    displayActions(item, index) {
      this.flagAdd = false;
      this.editedIndex = this.items[0].dataResponse.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.token = this.editedItem.apI_Key;
      this.tokenName = this.editedItem.tokenName;
      this.id = this.editedItem.id;
      this.DateSelected = 30;
      if (index === 0) {
        this.radios = "CustomeSelectDate";
        this.email = this.editedItem.eMail;
        this.EndDate = this.editedItem.endDate;
        this.GPTModel = this.editedItem.gptModelID;
        this.GroupModel = this.editedItem.groupModelID;
        this.dialogRenew = true;
      } else if (index === 1) {
        this.dialogRevoke = true;
      }
    },
    Add() {
      this.flagAdd = true;
      this.radios = "CustomeSelectDate";
      this.dialogRenew = true;

      this.tokenName = "";
      this.email = "";
      this.EndDate = this.nowDate;
      this.addItem.endDate = this.nowDate;
      this.GPTModel = null;
      this.GroupModel = null;
    },

    async CreateNewAPIToken() {
      try {
        let self = this;
        let emailvali = self.validateEmail(self.email);
        if (
          self.tokenName != null &&
          self.email != null &&
          self.tokenName != "" &&
          self.email != "" &&
          self.tokenName != undefined &&
          self.email != undefined &&
          emailvali == true
        ) {
          self.dialog = true;
          let EndDate =
            self.radios == "CustomeSelectDate"
              ? self.EndDate
              : self.convertDateToStringFormatDatePick(
                  new Date(
                    self.date.getFullYear(),
                    self.date.getMonth(),
                    self.date.getDate() + self.DateSelected
                  )
                );
          let temp = {
            tokenName: self.tokenName,
            eMail: self.email,
            endDate: EndDate,
            GPTModelID: self.GPTModel,
            GroupModelID: self.GroupModel,
          };
          await self.$call.CreateAPIToken(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dialog = false;
                if (dataResponse.data == "Data is duplicate") {
                  self.$swal.fire({
                    icon: "warning",
                    title: self.$t("warning"),
                    text: dataResponse.data,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                    backdrop: false 
                  });
                  self.dialogRenew = false;
                  self.GetAPIData();
                }
              } else {
                self.dialogRenew = false;
                self.dialog = false;
              }
            },
            (errorResource) => {
              self.dialog = false;
              if (errorResource.status != 0) {
                console.error(errorResource);
              }
            }
          );
        } else {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("pleasefillininformation"),
            showConfirmButton: false,
            timer: 1800,
          });
        }
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    async Renew() {
      try {
        let self = this;
        let emailvali = self.validateEmail(self.email);
        if (
          self.tokenName != null &&
          self.email != null &&
          self.tokenName != "" &&
          self.email != "" &&
          self.tokenName != undefined &&
          self.email != undefined &&
          emailvali == true
        ) {
          self.dialog = true;
          let EndDate =
            self.radios == "CustomeSelectDate"
              ? self.EndDate
              : self.convertDateToStringFormatDatePick(
                  new Date(
                    self.date.getFullYear(),
                    self.date.getMonth(),
                    self.date.getDate() + self.DateSelected
                  )
                );
          let temp = {
            id: self.id,
            tokenName: self.tokenName,
            eMail: self.email,
            endDate: EndDate,
            GPTModelID: self.GPTModel,
            GroupModelID: self.GroupModel,
          };
          await self.$call.RenewAPIToken(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dialog = false;
                if (dataResponse.data == "Data is duplicate") {
                  self.$swal.fire({
                    icon: "warning",
                    title: self.$t("warning"),
                    text: dataResponse.data,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.dialogRenew = false;
                  self.GetAPIData();
                }
              } else {
                self.dialogRenew = false;
                self.dialog = false;
              }
            },
            (errorResource) => {
              self.dialog = false;
              if (errorResource.status != 0) {
                console.error(errorResource);
              }
            }
          );
        } else {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("pleasefillininformation"),
            showConfirmButton: false,
            timer: 1800,
          });
        }
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    async Revork() {
      try {
        let self = this;
        self.dialog = true;
        let temp = {
          id: self.id,
        };
        self.$call.RevorkAPIToken(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1800,
              });
              self.dialog = false;
              self.GetAPIData();
            } else {
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1800,
              });
              self.dialog = false;
              self.GetAPIData();
            }
            self.dialog = false;
            self.isFirst = false;
            self.dialogRevoke = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },
    updateExampleCode(index) {
      // Login EXT
      if (index == 2) {
        const child = this.items[index].scriptAndParam;
        let UserName = child[1].script;
        let Password = child[2].script;
        const exampleItem = this.items[index].example[0];

        exampleItem.codeEx = `let _data = {
  "userName": "${UserName}",
  "password": "${Password}"
} 
let responseData = {
  "userId": 0,
  "username": "",
  "fullName": "",
  "passwordUpdateDate": null,
  "memberId": 0,
  "roleId": 0,
  "activeFlag": true,
  "userType": null,
  "token": "",
  "email": null
}
axios
  .post(
    "${this.urlApi}api/${this.versions.value}/ExternalAPI/Login",_data
  )
  .then(function(res) {
    let resData = res.data;
    responseData = resData;
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      // Vector Insert
      else if (index == 3) {
        const child = this.items[index].scriptAndParam;
        let vectordbName = child[1].script;
        let text = child[2].script;
        let createFlag = child[3].script;
        let token = child[4].script;
        const exampleItem = this.items[index].example[0];
        exampleItem.codeEx = `let _data = {
  "vectordbName": "${vectordbName}",
  "text": "${text}",
  "createFlag": ${createFlag}
}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/CreateVector",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      // List Vector Insert
      else if (index == 4) {
        const child = this.items[index].scriptAndParam;
        let vectordbName = child[1].script;
        let text = child[2].script;
        let createFlag = child[3].script;
        let token = child[4].script;
        const exampleItem = this.items[index].example[0];
        exampleItem.codeEx = `let _data = {
  "vectordbName": "${vectordbName}",
  "text": [${text}],
  "createFlag": ${createFlag}
}
axios
  .post(
    "${this.urlApi}api/${
          this.selectVersion
        }/ExternalAPI/CreateListVector",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      // Selector Model
      else if (index == 5) {
        const child = this.items[index].scriptAndParam;
        let type = child[1].script;
        let timestamp = child[2].script;
        let userId = child[3].script;
        let text = child[4].script;
        let token = child[5].script;
        const exampleItem = this.items[index].example[0];
        exampleItem.codeEx = `let _data = { 
  "events": [
    {
      "type": ${type},
      "timestamp": ${timestamp},
      "source": {
          "userId": "${userId}"
          },
      "message": {
          "text": "${text}"
          }
    }
  ]
}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/SelectorModel",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      //ChatPOST
      else if (index == 6) {
        const child = this.items[index].scriptAndParam;
        let type = child[1].script;
        let timestamp = child[2].script;
        let userId = child[3].script;
        let text = child[4].script;
        let token = child[5].script;
        const exampleItem = this.items[index].example[0];
        let parameterRequest =
          this.selectVersion != "v2"
            ? `let _data = {
  "events": [
    {
      "type": ${type},
      "timestamp": ${timestamp},
      "source": {
          "userId": "${userId}"
          },
      "message": {
          "text": "${text}"
          }
    }
  ]
}`
            : `let _data = new FormData();
  if (file) {
    formData.append("Image", file); // Type file image only
  } 
  formData.append("userId", "${userId}");
  formData.append("text", "${text}");
`;
        exampleItem.codeEx = `${parameterRequest}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPOST",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      //ChatPOST
      else if (index == 7) {
        const child = this.items[index].scriptAndParam;
        let type = child[1].script;
        let timestamp = child[2].script;
        let userId = child[3].script;
        let text = child[4].script;
        let promttext = child[5].script;
        let token = child[6].script;
        const exampleItem = this.items[index].example[0];
        let parameterRequest =
          this.selectVersion != "v2"
            ? `let _data = {
  "events": [
    {
      "type": ${type},
      "timestamp": ${timestamp},
      "source": {
          "userId": "${userId}"
          },
      "message": {
          "text": "${text}",
          "prompttext": "${promttext}"
          }
    }
  ]
}`
            : `let _data = new FormData();
  if (file) {
    formData.append("Image", file); // Type file image only
  }
  formData.append("userId", "${userId}");
  formData.append("text", "${text}");
  formData.append("prompttext", "${promttext}");
`;
        exampleItem.codeEx = `let _data = ${parameterRequest}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPromptPOST",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      //ImportUser
      else if (index == 8) {
        const child = this.items[index].scriptAndParam;
        let username = child[1].script;
        let passwrod = child[2].script;
        let firstName = child[3].script;
        let lastName = child[4].script;
        let email = child[5].script;
        let mobile = child[6].script;
        let modelID = child[7].script;
        let roleId = child[8].script;
        let token = child[9].script;
        const exampleItem = this.items[index].example[0];
        exampleItem.codeEx = `let _data = [
  {
    "username": "${username}",
    "passwrod": "${passwrod}",
    "firstName": "${firstName}",
    "lastName": "${lastName}",
    "email": "${email}",
    "mobile": "${mobile}",
    "modelID": "${modelID}",
    "roleId": ${roleId},
  },
]
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUser",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
      //ImportUserChat
      else if (index == 9) {
        const child = this.items[index].scriptAndParam;
        let username = child[1].script;
        let passwrod = child[2].script;
        let firstName = child[3].script;
        let lastName = child[4].script;
        let email = child[5].script;
        let mobile = child[6].script;
        let modelID = child[7].script;
        let socialUserID = child[8].script;
        let groupModelName = child[9].script;
        let modelQuickGroupName = child[10].script;
        let token = child[11].script;
        const exampleItem = this.items[index].example[0];
        exampleItem.codeEx = `let _data = [
  {
    "username": "${username}",
    "passwrod": "${passwrod}",
    "firstName": "${firstName}",
    "lastName": "${lastName}",
    "email": "${email}",
    "mobile": "${mobile}",
    "modelID": "${modelID}",
    "socialUserID": "${socialUserID}",
    "groupModelName": "${groupModelName}",
    "modelQuickGroupName": "${modelQuickGroupName}"
  },
]
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUserChat",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
          this.selectVersion == "v0"
            ? '"Bearer ' + token + '"'
            : "`" + token + "`"
        },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
      }
    },
    switchVersion() {
      for (let index = 3; index < this.items.length; index++) {
        // Vector Insert
        if (index == 3) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/CreateVector`;
          let vectordbName = child[1].script;
          let text = child[2].script;
          let createFlag = child[3].script;
          let token = child[4].script;
          this.items[index].scriptAndParam[4].content = `${
            this.selectVersion == "v0" ? "Token" : "API-Key"
          }`;
          this.items[index].scriptAndParam[4].tooltip = `${
            this.selectVersion == "v0"
              ? "ให้นำ Token ที่ได้จากการใช้ API: LoginEXT "
              : "ให้นำ API-Key จาก Token management มาใช้"
          }`;

          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `let _data = {
  "vectordbName": "${vectordbName}",
  "text": "${text}",
  "createFlag": ${createFlag}
}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/CreateVector",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        // List Vector Insert
        else if (index == 4) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/CreateListVector`;
          let vectordbName = child[1].script;
          let text = child[2].script;
          let createFlag = child[3].script;
          let token = child[4].script;
          this.items[index].scriptAndParam[4].content = `${
            this.selectVersion == "v0" ? "Token" : "API-Key"
          }`;
          this.items[index].scriptAndParam[4].tooltip = `${
            this.selectVersion == "v0"
              ? "ให้นำ Token ที่ได้จากการใช้ API: LoginEXT "
              : "ให้นำ API-Key จาก Token management มาใช้"
          }`;

          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `let _data = {
  "vectordbName": "${vectordbName}",
  "text": [${text}],
  "createFlag": ${createFlag}
}
axios
  .post(
    "${this.urlApi}api/${
            this.selectVersion
          }/ExternalAPI/CreateListVector",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        // Selector Model
        else if (index == 5) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/SelectorModel`;
          let type = child[1].script;
          let timestamp = child[2].script;
          let userId = child[3].script;
          let text = child[4].script;
          let token = child[5].script;
          this.items[index].scriptAndParam[5].content = `${
            this.selectVersion == "v0" ? "Token" : "API-Key"
          }`;
          this.items[index].scriptAndParam[5].tooltip = `${
            this.selectVersion == "v0"
              ? "ให้นำ Token ที่ได้จากการใช้ API: LoginEXT "
              : "ให้นำ API-Key จาก Token management มาใช้"
          }`;

          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `let _data = { 
  "events": [
    {
      "type": ${type},
      "timestamp": ${timestamp},
      "source": {
          "userId": "${userId}"
          },
      "message": {
          "text": "${text}"
          }
    }
  ]
}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/SelectorModel",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        //ChatPOST
        else if (index == 6) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPOST`;
          let type = child[1].script;
          let timestamp = child[2].script;
          let userId = child[3].script;
          let text = child[4].script;
          let token = child[5].script;
          this.items[index].scriptAndParam[5].content = `${
            this.selectVersion == "v0" ? "Token" : "API-Key"
          }`;
          this.items[index].scriptAndParam[5].tooltip = `${
            this.selectVersion == "v0"
              ? "ให้นำ Token ที่ได้จากการใช้ API: LoginEXT "
              : "ให้นำ API-Key จาก Token management มาใช้"
          }`;
          let parameterRequest = "";
          if (this.selectVersion != "v2" && this.selectVersion != "v3") {
            parameterRequest = `let _data = {
            "events": [
              {
                "type": ${type},
                "timestamp": ${timestamp},
                "source": {
                    "userId": "${userId}"
                    },
                "message": {
                    "text": "${text}"
                    }
              }
            ]
          }`;
          } else {
            parameterRequest = `let _data = new FormData();
          if (file) {
            formData.append("Image", file); // Type file image only
          } 
          formData.append("userId", "${userId}");
          formData.append("text", "${text}");`;
          }
          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `${parameterRequest}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPOST",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        //ChatPOST
        else if (index == 7) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPromptPOST`;
          let type = child[1].script;
          let timestamp = child[2].script;
          let userId = child[3].script;
          let text = child[4].script;
          let promttext = child[5].script;
          let token = child[6].script;
          this.items[index].scriptAndParam[6].content = `${
            this.selectVersion == "v0" ? "Token" : "API-Key"
          }`;
          this.items[index].scriptAndParam[6].tooltip = `${
            this.selectVersion == "v0"
              ? "ให้นำ Token ที่ได้จากการใช้ API: LoginEXT "
              : "ให้นำ API-Key จาก Token management มาใช้"
          }`;
          let parameterRequest = "";
          if (this.selectVersion != "v2" && this.selectVersion != "v3") {
            parameterRequest = `let _data = {
            "events": [
              {
                "type": ${type},
                "timestamp": ${timestamp},
                "source": {
                    "userId": "${userId}"
                    },
                "message": {
                    "text": "${text}",
                    "prompttext": "${promttext}"
                    }
              }
            ]
          }`;
          } else {
            parameterRequest = `let _data = new FormData();
          if (file) {
            formData.append("Image", file); // Type file image only
          } 
          formData.append("userId", "${userId}");
          formData.append("text", "${text}");
          formData.append("prompttext", "${promttext}");`;
          }

          // 'Version 0 ให้นำ Token ที่ได้จากการใช้ API: LoginEXT หากใช้ \n'+
          // 'Version 1 ให้นำ API-Key จากมาใช้แทน'

          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `${parameterRequest}
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ChatPromptPOST",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        //ImportUser
        else if (index == 8) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUser`;
          let username = child[1].script;
          let passwrod = child[2].script;
          let firstName = child[3].script;
          let lastName = child[4].script;
          let email = child[5].script;
          let mobile = child[6].script;
          let modelID = child[7].script;
          let roleId = child[8].script;
          let token = child[9].script;
          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `let _data = [
  {
    "username": "${username}",
    "passwrod": "${passwrod}",
    "firstName": "${firstName}",
    "lastName": "${lastName}",
    "email": "${email}",
    "mobile": "${mobile}",
    "modelID": "${modelID}",
    "roleId": ${roleId},
  },
]
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUser",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
        //ImportUserChat
        else if (index == 9) {
          const child = this.items[index].scriptAndParam;
          this.items[
            index
          ].scriptAndParam[0].script = `${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUserChat`;
          let username = child[1].script;
          let passwrod = child[2].script;
          let firstName = child[3].script;
          let lastName = child[4].script;
          let email = child[5].script;
          let mobile = child[6].script;
          let modelID = child[7].script;
          let socialUserID = child[8].script;
          let groupModelName = child[9].script;
          let modelQuickGroupName = child[10].script;
          let token = child[11].script;
          const exampleItem = this.items[index].example[0];
          exampleItem.codeEx = `let _data = [
  {
    "username": "${username}",
    "passwrod": "${passwrod}",
    "firstName": "${firstName}",
    "lastName": "${lastName}",
    "email": "${email}",
    "mobile": "${mobile}",
    "modelID": "${modelID}",
    "socialUserID": "${socialUserID}",
    "groupModelName": "${groupModelName}",
    "modelQuickGroupName": "${modelQuickGroupName}"
  },
]
axios
  .post(
    "${this.urlApi}api/${this.selectVersion}/ExternalAPI/ImportUserChat",_data,{
      headers:{
          ${this.selectVersion == "v0" ? "Authorization" : "'Api-Key'"}: ${
            this.selectVersion == "v0"
              ? '"Bearer ' + token + '"'
              : "`" + token + "`"
          },
        }
    }
  )
  .then(function(res) {
    let resData = res.data;
    console.log(resData);
  })
  .catch(function(error) {
    console.log(error);
  });`;
        }
      }
    },
    handlebars(code) {
      let type = "handlebars";
      let value = `<code class="language-${type}">${highlight(
        code,
        languages[type],
        type
      )}</code>`;
      return value;
    },
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    copyClipboard(index, side) {
      let text = document.createElement("textarea");
      text.value =
        side == "left"
          ? this.items[this.tab].scriptAndParam[index].script
          : this.items[this.tab].example[index].codeEx;
      text.focus();
      document.body.appendChild(text);
      text.select();
      // navigator.clipboard.writeText(text);
      document.execCommand("copy");
      text.parentNode.removeChild(text);
    },
    ClipboardAPIKey(item) {
      this.editedIndex = this.items[0].dataResponse.indexOf(item);
      let text = item.apI_Key;

      // ใช้ Clipboard API
      navigator.clipboard.writeText(text);

      // สร้าง array ใหม่เพื่อให้ Vue ตรวจจับการเปลี่ยนแปลง
      this.items[0].dataResponse = this.items[0].dataResponse.map(
        (obj, index) => {
          if (index === this.editedIndex) {
            return {
              ...obj,
              copy_status: true,
            };
          } else {
            return {
              ...obj,
              copy_status: false,
            };
          }
        }
      );

      setTimeout(() => {
        this.items[0].dataResponse = this.items[0].dataResponse.map(
          (obj, index) => {
            if (index === this.editedIndex) {
              return {
                ...obj,
                copy_status: false,
              };
            }
            return obj;
          }
        );
      }, 1800);
    },

    ShowAPIKey(item) {
      this.editedIndex = this.items[0].dataResponse.indexOf(item);

      // สร้าง array ใหม่เพื่อให้ Vue ตรวจจับการเปลี่ยนแปลง
      this.items[0].dataResponse = this.items[0].dataResponse.map(
        (obj, index) => {
          if (index === this.editedIndex) {
            return {
              ...obj,
              show_status: !obj.show_status,
              copy_status: false,
            };
          } else {
            return {
              ...obj,
              show_status: false,
              copy_status: false,
            };
          }
        }
      );
    },

    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          // self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGroupModel() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupModel = dataResponse.data;
          } else {
            self.DDGroupModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
/* Container */
.external-connector-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 24px;
}

/* Page Header */
.page-header {
  margin-bottom: 32px;
  margin-top: 20px;
}

/* Main Card */
.main-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Tabs */
.tabs-container {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 32px;
}

.tabs-wrapper {
  display: flex;
  gap: 4px;
  padding: 8px 0;
}

.tab-item {
  padding: 12px 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #64748b;
  background: transparent;
}

.tab-item:hover {
  background: #e2e8f0;
  color: #475569;
}

.tab-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.tab-text {
  font-size: 0.875rem;
}

/* Tab Content */
.tab-content {
  padding: 32px;
}

.tab-panel {
  min-height: 400px;
}

/* Action Bar */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.add-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

/* Table */
.table-container {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.modern-table >>> thead tr {
  background: #f8fafc;
}

.modern-table >>> thead th {
  color: #475569 !important;
  font-weight: 600;
  padding: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.modern-table >>> tbody tr {
  transition: all 0.2s ease;
}

.modern-table >>> tbody tr:hover {
  background: #f8fafc;
}

.modern-table >>> tbody td {
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
}

/* API Key Components */
.api-key-container {
  position: relative;
}

.api-key-display {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.api-key-input {
  flex: 1;
  border: none;
  background: transparent;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  color: #475569;
}

.icon-button {
  background: transparent;
  border: none;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s ease;
}

.icon-button:hover {
  background: #e2e8f0;
  color: #475569;
}

.copy-button {
  color: #059669;
}

.copy-toast {
  position: absolute;
  top: -8px;
  right: 0;
  background: #059669;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  z-index: 10;
  animation: fadeInOut 1.8s ease-in-out;
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
    transform: translateY(4px);
  }
  10%,
  90% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.expired {
  background: #fee2e2;
  color: #991b1b;
}

/* Action Menu */
.action-menu-button {
  background: transparent;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s ease;
}

.action-menu-button:hover {
  background: #f1f5f9;
  color: #475569;
}

.action-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.action-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.action-item:hover {
  background: #f8fafc;
}

/* API Documentation */
.api-docs-panel {
  height: 100%;
}

.docs-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  height: 100%;
}

.section-card {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  height: 100%;
  overflow-y: auto;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 24px 0;
}

/* Parameters */
.param-item {
  margin-bottom: 24px;
}

.divider {
  margin: 32px 0 24px 0;
  padding-top: 24px;
  border-top: 2px solid #e2e8f0;
}

.divider-title {
  color: #667eea;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.param-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.param-name {
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.param-type {
  background: #e2e8f0;
  color: #475569;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-family: "Monaco", "Consolas", monospace;
}

.info-icon {
  color: #64748b;
  cursor: help;
}

.param-input {
  position: relative;
}

.modern-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  background: white;
  resize: vertical;
  min-height: 80px;
}

.modern-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.copy-param-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s ease;
}

.copy-param-button:hover {
  background: #e2e8f0;
  color: #475569;
}

/* Response Section */
.response-section {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 2px solid #e2e8f0;
}

.status-responses {
  margin-bottom: 24px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border-radius: 8px;
  margin-bottom: 8px;
}

.status-code {
  background: #10b981;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
}

.status-message {
  font-family: "Monaco", "Consolas", monospace;
  color: #475569;
}

/* Code Examples */
.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.version-select {
  max-width: 200px;
}

.code-example {
  margin-bottom: 24px;
}

.code-label {
  color: #64748b;
  font-size: 0.875rem;
  margin-bottom: 8px;
  font-weight: 500;
}

.code-container {
  position: relative;
  background: #1a202c;
  border-radius: 12px;
  overflow: hidden;
}

.modern-code-editor {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.6;
}

.copy-code-button {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  color: #a0aec0;
  transition: all 0.2s ease;
}

.copy-code-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* Dialog Base */
/* .modern-dialog >>> .v-overlay__content {
  border-radius: 20px;
  overflow: hidden;
} */

.header-icon {
  margin-right: 16px;
  background: white;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.header-content {
  flex: 1;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  color: #64748b;
}

.header-text-content {
  flex: 1;
  min-width: 0;
}

.header-actions {
  flex-shrink: 0;
  margin-left: 16px;
}

/* .close-button {
  color: #9ca3af !important;
  background: #f9fafb !important;
  border: 1px solid #e5e7eb;
  border-radius: 8px !important;
  width: 36px !important;
  height: 36px !important;
  transition: all 0.2s ease;
}

.close-button:hover {
  color: #6b7280 !important;
  background: #f3f4f6 !important;
  border-color: #d1d5db;
  transform: scale(1.05);
}

.close-button:active {
  transform: scale(0.98);
} */
.usage-info {
  margin-bottom: 24px;
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 12px;
  padding: 16px;
}

.info-icon {
  margin-top: 1px;
  flex-shrink: 0;
}

.inline-code {
  background: #1e293b;
  color: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
}

.token-display-container {
  margin-bottom: 24px;
}

.token-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.token-input-wrapper {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px;
  transition: all 0.2s ease;
}

.token-input-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.token-input {
  flex: 1;
  background: transparent;
  border: none;
  padding: 12px 16px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  color: #374151;
  outline: none;
}

.copy-btn {
  margin-right: 8px;
  color: #059669 !important;
  background: rgba(5, 150, 105, 0.1) !important;
}

.copy-btn:hover {
  background: rgba(5, 150, 105, 0.2) !important;
}

/* Form Sections */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 1rem;
  font-weight: 650;
  color: #1e293b;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e2e8f0;
}

.form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.modern-input >>> .v-field {
  border-radius: 12px;
  background: #fafbfc;
}

.modern-input >>> .v-field__outline {
  color: #d1d5db;
}

.modern-input >>> .v-field--focused .v-field__outline {
  color: #3b82f6;
  border-width: 2px;
}

.current-token {
  margin-top: 20px;
}

.token-display {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px;
}

.current-token-input {
  flex: 1;
  background: transparent;
  border: none;
  padding: 10px 12px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  color: #6b7280;
  outline: none;
}

.copy-btn-inline {
  color: #059669 !important;
  margin-right: 4px;
}

/* Radio Group */
.radio-group-modern {
  margin: 0;
}

.radio-option {
  background: #fafbfc;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 16px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.radio-option:hover {
  border-color: #d1d5db;
}

.radio-option:has(.v-radio-group input:checked) {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.custom-radio {
  padding: 16px 20px 12px 20px;
  margin: 0;
}

.custom-radio >>> .v-selection-control__wrapper {
  margin-right: 16px;
}

.radio-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.radio-title {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.9375rem;
}

.radio-description {
  font-size: 0.8125rem;
  color: #6b7280;
}

.radio-input {
  padding: 0 20px 16px 20px;
  border-top: 1px solid #e5e7eb;
  background: white;
}

.duration-select-modern,
.date-input-modern {
  margin-top: 12px;
}

.duration-select-modern >>> .v-field,
.date-input-modern >>> .v-field {
  border-radius: 8px;
  background: white;
}

/* Warning Components */
.warning-container {
  text-align: center;
  padding: 20px;
}

.warning-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.warning-icon-large {
  background: #fef2f2;
  padding: 20px;
  border-radius: 20px;
  border: 4px solid #fecaca;
}

.warning-text {
  max-width: 320px;
}

.warning-message {
  font-size: 0.9375rem;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.highlight {
  background: #fef2f2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}

.token-info {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.token-label-small {
  font-size: 0.8125rem;
  color: #6b7280;
}

.token-name-display {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.875rem;
}

/* Dialog Footer */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 28px 28px 28px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

/* Buttons */
.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
}

.cancel-btn:hover {
  background: rgba(107, 114, 128, 0.1) !important;
}

.primary-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  border-radius: 12px !important;
}

.primary-btn:hover {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
  transform: translateY(-1px);
}

.danger-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
  border-radius: 12px !important;
}

.danger-btn:hover {
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.6);
  transform: translateY(-1px);
}

/* Loading */
.loading-overlay >>> .v-overlay__scrim {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(4px);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.loading-text {
  font-weight: 600;
  color: #374151;
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .docs-layout {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .form-grid-2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .external-connector-container {
    padding: 16px;
  }

  .tab-content {
    padding: 16px;
  }
}

.my-editor {
  background: #1e293b !important;
  color: #f1f5f9 !important;
  border-radius: 12px;
  font-family: "JetBrains Mono", "Monaco", "Consolas", monospace;
}

.my-editor >>> .token.comment,
.my-editor >>> .token.prolog,
.my-editor >>> .token.doctype,
.my-editor >>> .token.cdata {
  color: #64748b;
}

.my-editor >>> .token.punctuation {
  color: #94a3b8;
}

.my-editor >>> .token.property,
.my-editor >>> .token.tag,
.my-editor >>> .token.boolean,
.my-editor >>> .token.number,
.my-editor >>> .token.constant,
.my-editor >>> .token.symbol,
.my-editor >>> .token.deleted {
  color: #f59e0b;
}

.my-editor >>> .token.selector,
.my-editor >>> .token.attr-name,
.my-editor >>> .token.string,
.my-editor >>> .token.char,
.my-editor >>> .token.builtin,
.my-editor >>> .token.inserted {
  color: #10b981;
}

.my-editor >>> .token.operator,
.my-editor >>> .token.entity,
.my-editor >>> .token.url,
.my-editor >>> .language-css .token.string,
.my-editor >>> .style .token.string {
  color: #06b6d4;
}

.my-editor >>> .token.atrule,
.my-editor >>> .token.attr-value,
.my-editor >>> .token.keyword {
  color: #8b5cf6;
}

.my-editor >>> .token.function,
.my-editor >>> .token.class-name {
  color: #3b82f6;
}

.my-editor >>> .token.regex,
.my-editor >>> .token.important,
.my-editor >>> .token.variable {
  color: #ef4444;
}

/* Line numbers styling */
.my-editor >>> .prism-editor__line-numbers {
  background: #1e293b !important;
  color: #64748b !important;
  border-right: 1px solid #334155;
}
</style>
